<template>
    <ion-skeleton-text v-if="show" animated :class="skeletonClass" class="m-0"/>

    <template v-else>
        <slot/>
    </template>
</template>

<script setup lang="ts">
import { IonSkeletonText } from "@ionic/vue";
import { computed } from "vue";

import { SkeletonBaseProps } from "@/types/props";

const props = defineProps<SkeletonBaseProps>()

const skeletonClass = computed<string>(() => {
    let className = 'skeleton-'

    if (!props.variants) return 'skeleton-purple-light-background ' + (props.class ?? '')

    if (!props.variants.light) className += 'purple-'
    else className += `${props.variants.light}-`

    if (!props.variants.dark) className += 'light-background '
    else className += `${props.variants.dark}-background `

    return className + (props.class ?? '')
})
</script>
